import React from "react";
import { makeStyles } from "@mui/styles";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

// Theme
import theme from "../../themes/mdc-theme";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: 0,
    fontSize: "1.5rem",
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepper: {
    "&.MuiStepIcon-root.MuiStepIcon-active": {
      color: "red",
    },
  },
  customLabelStyle: {
    fontSize: "1.5rem !important",
  },
  icon: {
    "&..MuiStepLabel-label": {
      fontSize: "1.5rem !important",
    },
    color: theme.palette.MDCColors?.color18,
    "&$activeIcon": {
      color: theme.palette.MDCColors?.color18,
    },
    "&$completedIcon": {
      color: theme.palette.MDCColors?.color23,
    },

    "& .MuiStepIcon-text": {
      color: theme.palette.MDCColors?.black,
      fill: theme.palette.MDCColors?.white,
      fontSize: "0.75rem",
    },
  },
  activeIcon: {},
  highlightedActiveIcon: {
    "&$activeIcon": {
      color: theme.palette.MDCColors?.color23,
    },
  },
  completedIcon: {},
}));

function getSteps() {
  return [1, 2, 3];
}

export default function MDCStepper({
  step,
  steps: customSteps,
  labelClassName,
  alternativeLabel,
  activeStepEnabled,
}) {
  const classes = useStyles();
  const steps = customSteps && customSteps.length ? customSteps : getSteps();

  return (
    <div className={classes.root}>
      <Stepper
        activeStep={step}
        className={classes.stepper}
        alternativeLabel={alternativeLabel}
      >
        {steps.map((label, index) => {
          const stepProps =
            activeStepEnabled === undefined
              ? {}
              : { active: activeStepEnabled && index === step };
          const labelProps = {};
          const isCustomLabel = typeof label === "string";

          return (
            <Step key={isCustomLabel ? label : index} {...stepProps}>
              <StepLabel
                {...labelProps}
                classes={{ label: labelClassName || classes.customLabelStyle }}
                StepIconProps={{
                  classes: {
                    root: `${classes.icon} ${
                      activeStepEnabled ? classes.highlightedActiveIcon : ""
                    }`,
                    active: classes.activeIcon,
                    completed: classes.completedIcon,
                  },
                }}
              >
                {isCustomLabel &&
                  label.split("\n").map((line, lineIndex) => (
                    <React.Fragment key={lineIndex}>
                      {lineIndex > 0 && <br />}
                      {line}
                    </React.Fragment>
                  ))}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}
